import React, { Component } from 'react';
import { connect } from 'react-redux';
import { reduxForm, reset, SubmissionError } from 'redux-form';
import { FormattedMessage } from 'react-intl';

import SignupForm, { FORM_NAME } from './form';
import Title from '../title';
import FacebookButton from '../../containers/facebook-button.container';
import { submitSignupForm, userExists } from '../../actions';
import { reportError } from '../../lib/error-reporter';

import logo from '../../img/keytravel-logo-white.png';

const COMPONENT_ID = 'SignupModal';

class SignupModal extends Component {

  state = {
    clearForm: false,
  }

  componentDidMount() {
    if (window.location.hash === '#signup') {
      window.$('#signup').modal('show');
    }

    window.$('#signup').on('hide.bs.modal', () => {
      window.location.hash = '#';
      this.setState({
        clearForm: true,
      });
    });
  }

  onClearForm = () => {
    this.setState({
      clearForm: false,
    });
  }

  onSubmit = (values) => {
    return this.props.submitSignupForm(values)
      .then(this.onSignup)
      .catch((error) => {
        reportError({
          error,
          component: COMPONENT_ID,
          params: {},
        });

        throw new SubmissionError({
          _error: error.message,
        });
      });
  }

  onSignup = () => this.hideThisModal();

  onEmailChange = (email) => {
    this.props.userExists(email);
  }

  onLoginClick = () => {
    this.hideThisModal();
    window.$('#signin').modal('show');
  }

  onFacebookConnect = () => this.hideThisModal();

  hideThisModal = () => {
    window.$('body').removeClass('modal-open');
    window.$('#signup').modal('hide');
    window.$('.modal-backdrop').hide();
    window.location.hash = '#';
    this.setState({
      clearForm: true,
    });
  }

  setupForm() {
    return reduxForm({
      form: FORM_NAME,
      onSubmitSuccess: (res, dispatch) => dispatch(reset(FORM_NAME)),
      destroyOnUnmount: false,
    })(SignupForm);
  }

  get emailInUse() {
    return !!this.props.existence;
  }

  get bodyHeader() {
    return (
      <div className="text-center">
        <h1>
          <FormattedMessage
            id="signupModal.pageTitle.title"
            defaultMessage="Create account"
          />
        </h1>
        <p className="text-muted">
          <FormattedMessage
            id="signupModal.pageTitle.subtext"
            defaultMessage="It's free, quick, safe, and spam-free"
          /><br />
          <FormattedMessage
            id="signupModal.pageTitle.haveAnAccount"
            defaultMessage="Already have an account?"
          />
          {' '}
          <a href="#signin" onClick={this.onLoginClick}>
            <FormattedMessage
              id="signupModal.pageTitle.signinLink"
              defaultMessage="Sign in"
            />
          </a>
        </p>
      </div>
    );
  }

  get connectWithFacebook() {
    return (
      <React.Fragment>
        <Title text={this.connectWithFacebookText}
          divider
        />

        <div className="my-3">
          <FacebookButton onConnect={this.onFacebookConnect}>
            <FormattedMessage
              id="signupModal.connectWithFacebook.button"
              defaultMessage="Connect with Facebook"
            />
          </FacebookButton>
          <span className="small-print">
            <FormattedMessage
              id="signupModal.connectWithFacebook.disclaimer"
              defaultMessage="We will never post on your behalf"
            />
          </span>
        </div>
      </React.Fragment>
    )
  }

  get connectWithFacebookText() {
    return (
      <FormattedMessage
        id="signupModal.connectWithFacebook.title"
        defaultMessage="Create your account in 1 click"
      />
    );
  }

  get signupForm() {
    if (!this._form) {
      this._form = this.setupForm();
    }
    return this._form;
  }

  render() {
    if (this.props.currentUser) return null;

    const Form = this.signupForm;

    return (
      <div className="accounts-modal modal" id="signup">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title pb-0 d-block w-100 text-center">
                <img src={logo} alt="Pay by group" height="24" />
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={() => this.hideThisModal()}
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </h5>
            </div>
            <div className="modal-body">
              {this.bodyHeader}
              {this.connectWithFacebook}
              <Title text="Or" divider />
              <Form
                emailInUse={this.emailInUse}
                onEmailChange={this.onEmailChange}
                onSubmit={this.onSubmit}
                onLoginClick={this.onLoginClick}
                clearForm={this.state.clearForm}
                onClearForm={this.onClearForm}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ users }) => {
  return {
    currentUser: users.byId[users.current],
    existence: users.existence,
  };
};

const mapDispatchToProps = {
  submitSignupForm,
  userExists,
};

export default connect(mapStateToProps, mapDispatchToProps)(SignupModal);



// WEBPACK FOOTER //
// ./src/desktop/components/signup-modal/index.js